import {Component} from 'react';
import {Alert} from 'react-bootstrap';

import {Routes} from "../_api/Api";

const routes = new Routes();

export class Loading extends Component {
    props: {
        message?: string,
        className?: string
    }

    render() {
        let {message = 'Aguarde', className = ''} = this.props;
        return <div className={`alert d-flex align-items-center justify-content-center rounded p-5 `
            + `text-center bg-light border shadow-md mb-0 ${className}`}>
            <h2 className="text-sesc-blue">
                <i className="fa fa-spinner fa-pulse"/> {' ' + message}
            </h2>
        </div>;
    }
}

export class SimpleLoading extends Component {
    props: {
        message?: string,
        className?: string
    }

    render() {
        let {message = 'Aguarde', className = ''} = this.props;
        return <div {...{className}}>
            <i className="fa fa-spinner fa-pulse"/> {message}
        </div>;
    }
}

export class PagseguroLoading extends Component {
    render() {
        return <Alert className="rounded p-5 text-center bg-green-pagseguro" variant="light">
            <h2 className="text-light">
                <i className="fa fa-spinner fa-pulse"/> Seguindo Para <br/>
                <img src={routes.img('pagseguro-logo')} alt="seguir para pagseguro"/>
            </h2>
        </Alert>;
    }
}
